/* sovabooks CRO helpers: coupon apply from announcement bar, mobile sticky add-to-cart. Vanilla JS, no deps. */
(function () {
  'use strict';
  if (window.__sovaCro) return;
  window.__sovaCro = true;

  var lang = String(document.documentElement.lang || 'ru').toLowerCase();

  function t(key, code) {
    var dict = {
      applied: {
        ru: 'Промокод ' + code + ' применён — скидка будет учтена при оформлении',
        uk: 'Промокод ' + code + ' застосовано — знижку буде враховано під час оформлення',
        pl: 'Kod ' + code + ' został zastosowany — rabat zostanie uwzględniony przy zamówieniu',
        en: 'Code ' + code + ' applied — the discount will be taken into account at checkout'
      },
      copied: {
        ru: 'Промокод ' + code + ' скопирован — введите его при оформлении',
        uk: 'Промокод ' + code + ' скопійовано — введіть його під час оформлення',
        pl: 'Kod ' + code + ' został skopiowany — wpisz go przy zamówieniu',
        en: 'Code ' + code + ' copied — enter it at checkout'
      }
    };
    var l = lang.indexOf('uk') === 0 ? 'uk' : lang.indexOf('pl') === 0 ? 'pl' : lang.indexOf('en') === 0 ? 'en' : 'ru';
    return dict[key][l];
  }

  /* ---------- toast ---------- */
  var toastEl = null;
  var toastTimer = null;
  function toast(text) {
    try {
      if (!document.body) return;
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'sova-cro-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = text;
      // force reflow so the transition runs when re-shown
      void toastEl.offsetWidth;
      toastEl.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        if (toastEl) toastEl.classList.remove('is-visible');
      }, 3500);
    } catch (e) {}
  }

  function copyText(text) {
    function fallback() {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none;font-size:16px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e1) {}
        document.body.removeChild(ta);
      } catch (e2) {}
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
        navigator.clipboard.writeText(text).catch(fallback);
        return;
      }
    } catch (e) {}
    fallback();
  }

  /* ---------- a) announcement bar coupon ---------- */
  var COUPON_CLASS = 'essential_annoucement_bar_coupon_code_button';
  var lastCouponAt = 0;

  function findCouponButton(e) {
    var path = (e.composedPath && e.composedPath()) || [];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1) continue;
      var cls = typeof node.className === 'string' ? node.className : (node.getAttribute && node.getAttribute('class')) || '';
      if (cls.indexOf(COUPON_CLASS) !== -1) return node;
    }
    var target = e.target;
    if (target && target.closest) return target.closest('[class*="' + COUPON_CLASS + '"]');
    return null;
  }

  function onCouponClick(e) {
    try {
      var btn = findCouponButton(e);
      if (!btn) return;
      var now = Date.now();
      if (now - lastCouponAt < 2000) return; // anti-rage debounce
      lastCouponAt = now;
      var raw = btn.getAttribute('data-code') || btn.getAttribute('data-coupon') || btn.textContent || '';
      var code = String(raw).trim().toUpperCase().replace(/[^0-9A-ZЀ-ӿ]/g, '');
      if (!code) return;
      copyText(code);
      var url = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart.js');
      if (!window.fetch) { toast(t('copied', code)); return; }
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { toast(t(r && r.ok ? 'applied' : 'copied', code)); })
        .catch(function () { toast(t('copied', code)); });
    } catch (err) {}
  }
  document.addEventListener('click', onCouponClick, true);

  /* ---------- b) mobile sticky add-to-cart ---------- */
  function cleanText(el) {
    if (!el) return '';
    return String(el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function initStickyAtc() {
    try {
      if (!document.body || document.querySelector('.sova-sticky-atc')) return;
      if (!('IntersectionObserver' in window) || !window.matchMedia) return;

      var mainBtn =
        document.querySelector('#MainContent product-info form[action*="/cart/add"] .product-form__submit') ||
        document.querySelector('#MainContent [id^="MainProduct"] form[action*="/cart/add"] .product-form__submit') ||
        document.querySelector('#MainContent form[action*="/cart/add"] .product-form__submit');
      var bodyCls = document.body.className || '';
      var isProduct = /template-product|custom--product/.test(bodyCls) || !!mainBtn;
      if (!isProduct || !mainBtn) return;

      var scope = mainBtn.closest('product-info, .product__info-container, .product, section') || document;
      var mq = window.matchMedia('(max-width: 749px)');

      var bar = document.createElement('div');
      bar.className = 'sova-sticky-atc';
      bar.setAttribute('aria-hidden', 'true');
      var info = document.createElement('div');
      info.className = 'sova-sticky-atc__info';
      var titleEl = document.createElement('div');
      titleEl.className = 'sova-sticky-atc__title';
      var priceEl = document.createElement('div');
      priceEl.className = 'sova-sticky-atc__price';
      info.appendChild(titleEl);
      info.appendChild(priceEl);
      var barBtn = document.createElement('button');
      barBtn.type = 'button';
      barBtn.className = 'button sova-sticky-atc__btn';
      barBtn.tabIndex = -1;
      bar.appendChild(info);
      bar.appendChild(barBtn);
      document.body.appendChild(bar);

      var passed = false; // main button scrolled above the viewport
      var shown = false;

      function getTitle() {
        var h = scope.querySelector && scope.querySelector('h1');
        return cleanText(h || document.querySelector('h1'));
      }

      function getPrice() {
        var root = (scope.querySelector && scope.querySelector('.price')) || document.querySelector('#MainContent .price');
        if (!root) return '';
        var onSale = root.classList.contains('price--on-sale');
        var el = onSale
          ? root.querySelector('.price__sale .price-item--sale') || root.querySelector('.price-item--sale')
          : root.querySelector('.price__regular .price-item--regular') || root.querySelector('.price-item--regular');
        var txt = cleanText(el);
        if (!txt) {
          var c = root.querySelector('.price__container');
          txt = cleanText(c);
        }
        return txt;
      }

      function getBtnText() {
        var span = mainBtn.querySelector('span');
        return cleanText(span) || cleanText(mainBtn);
      }

      function isVisibleEl(el) {
        if (!el || el === bar || bar.contains(el)) return false;
        var cs = window.getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
        var r = el.getBoundingClientRect();
        return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
      }

      function cookieBannerVisible() {
        var list;
        try {
          list = document.querySelectorAll(
            '[id*="shopify-pc__banner"],[class*="shopify-pc__banner"],[id*="cookie" i],[class*="cookie" i]'
          );
        } catch (e) {
          list = document.querySelectorAll('[id*="shopify-pc__banner"],[class*="shopify-pc__banner"],[id*="cookie"],[class*="cookie"]');
        }
        for (var i = 0; i < list.length; i++) {
          if (isVisibleEl(list[i])) return true;
        }
        return false;
      }

      function overlayOpen() {
        var b = document.body;
        return b.classList.contains('overflow-hidden') || b.classList.contains('overflow-hidden-mobile') ||
          b.classList.contains('overflow-hidden-tablet');
      }

      function setShown(on) {
        if (on === shown) return;
        shown = on;
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        barBtn.tabIndex = on ? 0 : -1;
        document.body.classList.toggle('sova-sticky-atc-on', on);
      }

      function update() {
        try {
          if (!document.body.contains(mainBtn)) { setShown(false); return; }
          var want = mq.matches && passed && !overlayOpen() && !cookieBannerVisible();
          if (want) {
            titleEl.textContent = getTitle();
            priceEl.textContent = getPrice();
            barBtn.textContent = getBtnText();
            var disabled = mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true';
            barBtn.disabled = !!disabled;
          }
          setShown(want);
        } catch (e) {}
      }

      barBtn.addEventListener('click', function () {
        try {
          if (barBtn.disabled || mainBtn.disabled) return;
          mainBtn.click();
        } catch (e) {}
      });

      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var en = entries[i];
          passed = !en.isIntersecting && en.boundingClientRect.bottom < 0;
        }
        update();
      });
      io.observe(mainBtn);

      try {
        new MutationObserver(function () { if (shown) update(); }).observe(mainBtn, {
          attributes: true, childList: true, characterData: true, subtree: true
        });
        new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      } catch (e) {}

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        (window.requestAnimationFrame || setTimeout)(function () { ticking = false; update(); });
      }, { passive: true });
      if (mq.addEventListener) mq.addEventListener('change', update);
      else if (mq.addListener) mq.addListener(update);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();


/* SOVABOOKS cart cross-sell responsive placement 2026-10-20 */
(function () {
  'use strict';
  function init() {
    var main = document.getElementById('MainContent');
    if (!main || !main.querySelector('cart-items')) return;
    var section = main.querySelector('[id$="__179205904527297dd9"]');
    if (!section) return;
    section.classList.add('sova-cart-cross-sell');
    var mq = window.matchMedia('(max-width:749px)');
    var pending = false;
    function place() {
      pending = false;
      var items = main.querySelector('cart-items');
      var blocks = main.querySelector('#main-cart-footer .cart__blocks');
      if (!items || !blocks) return;
      var itemsSection = items.closest('.shopify-section');
      var target = mq.matches ? itemsSection.parentNode : blocks;
      var before = mq.matches ? itemsSection : blocks.firstElementChild;
      if (section.parentNode !== target || (mq.matches && section.nextElementSibling !== itemsSection)) {
        target.insertBefore(section, before);
        window.dispatchEvent(new Event('resize'));
      }
    }
    function queue() { if (!pending) { pending = true; requestAnimationFrame(place); } }
    place();
    if (mq.addEventListener) mq.addEventListener('change', queue);
    else mq.addListener(queue);
    new MutationObserver(queue).observe(main, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
